var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quizProgress"},[_c('a-progress',{attrs:{"percent":_vm.$store.state.progress,"strokeLinecap":"square","show-info":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }